import React from "react";

import Image from "./Image";

function CreateServiceModalServicePickerOptionImage(props) {
  return (
    <div className="icon icon-huge icon-image-container icon-app-container">
      <Image {...props} />
    </div>
  );
}

module.exports = CreateServiceModalServicePickerOptionImage;



// WEBPACK FOOTER //
// ./src/js/components/CreateServiceModalServicePickerOptionImage.js